// generated by genversion
export var version = '5.0.13';
//# sourceMappingURL=version.js.map